module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-wrapper"
  }, [_c('div', {
    staticClass: "page-header translucent-wrapper",
    style: (_vm.headerStyle)
  }, [_c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "advantage-addition"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBondedLoanAdvantage(_vm.advantage.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить превью\n        ")])]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": function($event) {
        return _vm.updateBondedLoanAdvantage(_vm.advantage)
      }
    },
    model: {
      value: (_vm.advantage.title),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "title", $$v)
      },
      expression: "advantage.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    on: {
      "change": function($event) {
        return _vm.updateBondedLoanAdvantage(_vm.advantage)
      }
    },
    model: {
      value: (_vm.advantage.description),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "description", $$v)
      },
      expression: "advantage.description"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка на видео"
    },
    on: {
      "change": function($event) {
        return _vm.updateBondedLoanAdvantage(_vm.advantage)
      }
    },
    model: {
      value: (_vm.advantage.videoLink),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "videoLink", $$v)
      },
      expression: "advantage.videoLink"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticClass: "learn-more-field space-evenly"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок кнопки",
      "required": ""
    },
    model: {
      value: (_vm.advantage.buttonTitle),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "buttonTitle", $$v)
      },
      expression: "advantage.buttonTitle"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Ссылка",
      "required": ""
    },
    model: {
      value: (_vm.advantage.buttonLink),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "buttonLink", $$v)
      },
      expression: "advantage.buttonLink"
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0548e1a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/Advantage.vue
// module id = 885
// module chunks = 0